<app-companies-nav [activeMenuItem]="'companies'"></app-companies-nav>

<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50">
    <button mat-raised-button color="basic" (click)="returnBack()" style="margin-right: 10px;">Back</button>
  </div>
  <div fxFlex="50" class="text-right">
    <a mat-raised-button color="primary" routerLink="edit" *ngIf="editEnabled()">
      <mat-icon>edit</mat-icon>
      Edit
    </a>
  </div>
</div>

<div fxLayout="row" *ngIf="company">
  <mat-card class="content-card container-md" fxFlex="100">
    <div fxFlex="50">
      <h3 style="margin-bottom: 0">{{ company.name }}</h3>
      <div><small>{{company.brandName}}</small></div>

    </div>
    <div fxFlex="50" style="text-align: right">
      <mat-icon *ngIf="!company.logoUrl" class="">add_a_photo</mat-icon>
      <img *ngIf="company.logoUrl" class="logo" [src]="company.logoUrl">
    </div>
  </mat-card>
</div>




<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="40">
    <mat-card class="content-card ">
      <mat-card-header>
        <mat-card-title>
          <h5>Company Data</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="company-card">
        <div class="list-item" fxLayout="row" *ngFor="let field of fields">
          <app-content-row [field]="field" [entity]="company"></app-content-row>

        </div>
      </mat-card-content>

    </mat-card>
  </div>
  <div fxFlex="60">
    <ng-container *ngIf="company">
      <app-company-api-settings *appHasRoles="['admin']" [company]="company"></app-company-api-settings>
      <app-object-comments-view [comments]="comments" [objectId]="company?.id" [target]="commentsTarget">
      </app-object-comments-view>
    </ng-container>
    <app-event-log-view [logs]="logs" *ngIf="showLogs()"></app-event-log-view>
  </div>
</div>

<style type="text/css">
  .company-card .material-icons {
    font-size: 20px;
  }
</style>
